export default __webpack_public_path__ + "static/media/easterWonderlandBg.9fa02a00.jpg";